import './App.css';
import ReceiptGenerator from './ReceiptGenerator';

function App() {
  return (
    <div className="App">
      <ReceiptGenerator />
      {/* <h4>Something went wrong</h4> */}
    </div>
  );
}

export default App;
